
























































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
// import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
// Model
import DataExport from '@/models/dataExportSellingModel';
// Components
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import Dialog from '@/components/common/modules/Dialog.vue';

import MasterSelectControl from '@/components/common/modules/MasterSelectControl.vue';

import {
  DefaultSortRequest,
  DataExportButtons,
  DataReportOutputSellingSelectPlanAndActualForm,
  DataReportOutputSellingRepresentativeConditionsForm,
  CatchInputMasterIdList,
  PlanAndActualChangeForm
} from '@/constants/dataexport/dataexportselling';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';

import Encoding from 'encoding-japanese';

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    Dialog,
    MasterSelectControl,
    AutoCreateForm,
    SingleText,
    Button
  }
})

export default class DataExportList extends Vue {
  // model
  private dataExport = new DataExport();
  // アプリIDをセット
  private projectId = hexabaseState.applicationId;
  // 画面内ボタン
  private buttons = DataExportButtons;
  // 選択しているデータレポートのid
  private dataReportId = 'r_output_selling_representative';
  // 期間変更前のid
  private oldPlanActualName = '';
  // マスタデータ関連格納プロパティ
  private masterData: any = {};
  // Payload
  private csvPayload = {
    conditions: [] as Array<{ [key: string]: any }>,
    per_page: 0,
    page: 1,
    use_display_id: true,
    sort_fields: DefaultSortRequest,
    // format: 'csv',
    include_lookups: true,
  };
  // CSV出力されるファイル名
  private csvFileName = 'downloadSellingRepresentative';
  // 予実表示パネル
  private dataReportOutputSellingSelectPlanAndActualDatas = { cols: {}, datas: {} as { [k: string]: any } };
  // 出力条件表示パネル
  private outputConditionsItems = { cols: {}, datas: {} as { [k: string]: any } };
  // ステータスの選択肢を格納
  private statusOptionList: Array<{ [k: string]: string | number | any }> = [];
  // Dialog
  private apiDialog = false;
  private apiDialogBodyText = '';
  private apiDialogMaxWidth = '800';
  private apiDialogTableColumn: Array<{ [k: string]: string | number }> = [];
  private apiDialogErrData: Array<{ [k: string]: string | any }> = [];

  async created() {
    // 初期表示に必要な情報を取得
    try {
      this.$store.commit('hexabase/setIsLoading', true);

      const [masterData, reporDataSearchConditions] = await Promise.all([
        this.dataExport.getMasterData(),
        this.dataExport.getReportSearchConditions(this.projectId, this.dataReportId)
      ]);

      this.masterData = masterData;

      this.dataReportOutputSellingSelectPlanAndActualDatas = this.getHeaderFields(
        DataReportOutputSellingSelectPlanAndActualForm
      );
      const dataReportOutputSelectPlanAndActualData = {};
      this.getHeaderData(
        dataReportOutputSelectPlanAndActualData,
        this.dataReportOutputSellingSelectPlanAndActualDatas
      );

      // 出力条件
      this.outputConditionsItems = this.getHeaderFields(DataReportOutputSellingRepresentativeConditionsForm);
      const dataReportOutputConditionsItemData = {};
      this.getHeaderData(dataReportOutputConditionsItemData, this.outputConditionsItems);

      // ステータス
      const findIndex = this.dataFindIndex(reporDataSearchConditions, 'display_id', 'status');
      this.statusOptionList.push({ text: '全ステータス', value: [] });
      Object.keys(reporDataSearchConditions[findIndex].statuses).forEach(key => {
        reporDataSearchConditions[findIndex].statuses[key].value = [
          reporDataSearchConditions[findIndex].statuses[key].s_id
        ];
        reporDataSearchConditions[findIndex].statuses[key].text =
          reporDataSearchConditions[findIndex].statuses[key].name;
        this.statusOptionList.push(reporDataSearchConditions[findIndex].statuses[key]);
        this.statusOptionList[0].value.push(
          reporDataSearchConditions[findIndex].statuses[key].s_id
        );
      });
      this.outputConditionsItems.datas[1].props.selectData.options = JSON.parse(JSON.stringify(this.statusOptionList));
      // 部・課
      // 社員マスタから部・課で重複項目の除外
      const divisionOptionList: any = [];
      const mapItem: any = Array.from(
        new Map(this.masterData['m_employee']['body'].map((user:any) => [user.division, user])).values()
      ).filter((filterItem:any) => {
        // mapでundefined、文字無しなどが除外できないのでfilterで対応
        if(filterItem.division !== undefined) {
          if(filterItem.division.length !== 0) {
            return filterItem;
          }
        }
      });
      // SelectArea用にデータを整形し、設定する
      for (const index in mapItem) {
        divisionOptionList.push({text: mapItem[index].division, value: mapItem[index].division});
      }
      this.outputConditionsItems.datas[2].props.selectData.options = divisionOptionList;
      // サービス種別
      this.outputConditionsItems.datas[3].props.columns = this.masterData['m_service_type']['columns'];
      this.outputConditionsItems.datas[3].props.body = this.masterData['m_service_type']['body'];
      // 担当者
      const item = JSON.parse(JSON.stringify(this.masterData['m_employee']['columns']));
      // columnに会社名を追加
      item.push({
        'value': 'company_id',
        'text': '会社名',
        'width': '20%'
      });
      this.outputConditionsItems.datas[4].props.columns = item;
      this.outputConditionsItems.datas[4].props.body = this.masterData['m_employee']['body'];
      // 商材
      this.outputConditionsItems.datas[5].props.columns = this.masterData['m_commodity']['columns'];
      this.outputConditionsItems.datas[5].props.body = this.masterData['m_commodity']['body'];
      // 仕入れ先
      this.outputConditionsItems.datas[6].props.columns = this.masterData['m_supplier']['columns'];
      this.outputConditionsItems.datas[6].props.body = this.masterData['m_supplier']['body'];
    } catch (error) {
      this.setError(error);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  async buttonEvent(eventName: string) {
    switch (eventName) {
      case 'clearButton': {
        this.clearButton();
        break;
      }
      case 'SJIS': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          // 検索条件に部・課が含まれているかのチェック
          const searchItemIndex = this.csvPayload.conditions.findIndex(item=> {
            if ('division' === item.id) {
              return item;
            }
          });
          // 検索条件に部・課が含まれている場合に検索条件を抜出
          let searchDivisionItem: any;
          if (searchItemIndex !== -1) {
            searchDivisionItem = this.csvPayload.conditions.splice(searchItemIndex, 1);
          }

          const apiResponseData = await this.dataExport.getReports(
            hexabaseState.applicationId,
            this.dataReportId,
            this.csvPayload
          );

          if (apiResponseData) {
            if (searchDivisionItem !== undefined) {
              // 検索条件に部・課を戻す
              this.csvPayload.conditions.splice(searchItemIndex, 0, searchDivisionItem[0]); 
              // 取得結果を検索条件に含まれていた部・課で絞込を行う
              const filterData = apiResponseData.report_results.filter(item => {
                if (item.lookup_items !== undefined) {
                  if (item.lookup_items.manager_id !== undefined) {
                    return searchDivisionItem[0].search_value[0] === item.lookup_items.manager_id.division;
                  }
                }
              });
              apiResponseData.report_results = filterData;
            }
            // レスポンスをCSV形式に変換
            const responseData = this.dataExport.sellingConvertCsv(JSON.parse(JSON.stringify(apiResponseData)));

            if (eventName === 'SJIS') {
              // 文字コード変換(UNICODE->SJIS)
              const codeArray = Encoding.stringToCode(responseData.toString());
              const sjisArray = Encoding.convert(codeArray, 'SJIS', 'UNICODE');
              const uInt8List = new Uint8Array(sjisArray);
              // 取得したCSVデータをダウンロード
              this.dataExport.formOutPutDownload(uInt8List, this.csvFileName, 'csv');
            } else {
              // UNICODEのままの場合(BOMなし)
              this.dataExport.formOutPutDownload(responseData, this.csvFileName, 'csv');
            }
          }
        } catch (error) {
          this.setError(error);
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
    }
  }

  private setError(errorMessage: any): void {
    if (typeof errorMessage === 'object') errorMessage = this.dataExport.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  private async confirmOpratipon() {
    this.apiDialog = false;
    this.apiDialogTableColumn = [];
    this.apiDialogErrData = [];
  }

  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.dataExport.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  private catchInput(input: any) {
    let conditionItem: { [key: string]: any } = {};

    if (input.value === undefined) return;
    if (input.type === undefined) {
      switch (input.name) {
        case 'service_type':
        case 'division':
        case 'company_id':
        case 'manager_id':
        case 'commodity_id':
        case 'supplier_id': {
          const item = this.masterData[CatchInputMasterIdList[input.name]]['body'].find(
            (item: any) => {
              if (item.i_id === input.value) {
                return item;
              }
            }
          );
          if (item !== undefined) {
            conditionItem['id'] = input.name;
            conditionItem['search_value'] = [input.value];
          }
          break;
        }
      }
    } else {
      if (input.type === 'datetime') {
        const dateData = this.dataExport.editDatetype(input.value, 'Asia/Tokyo', 'yyyy/MM/dd');
        const item = JSON.parse(JSON.stringify(input));
        item.value = dateData;

        const findIndex = this.dataFindIndex(
          this.outputConditionsItems.datas,
          'display_id',
          input.name
        );
        if (findIndex !== -1) {
          if (input.range === 'from') {
            this.outputConditionsItems.datas[findIndex].props.valueFrom = input.value;
          } else {
            this.outputConditionsItems.datas[findIndex].props.valueTo = input.value;
          }
        }
        // 選択している予実に応じてidを変更
        item.name = this.outputConditionsItems.datas[findIndex].props.name;
        conditionItem = this.createSearchConditionList(item, this.csvPayload.conditions);
      } else {
        if (input.name === 'plan_actual') {
          // 予実を変更前のname取得
          const findIndex = this.dataFindIndex(
            this.outputConditionsItems.datas,
            'display_id',
            'expected_sales_date'
          );
          this.oldPlanActualName = this.outputConditionsItems.datas[findIndex].props.name;
          // 予実を変更で項目名を変更
          this.dataExport.changeFormLabel(PlanAndActualChangeForm[input.value], this.outputConditionsItems.datas);
          this.dataReportOutputSellingSelectPlanAndActualDatas.datas[0].props.value = input.value;
          // 検索条件保持済みの場合入れ替え
          const findIndexCondition = this.dataFindIndex(this.csvPayload.conditions, 'id', this.oldPlanActualName);
          if (findIndexCondition !== -1) {
            this.csvPayload.conditions[findIndexCondition].id = this.outputConditionsItems.datas[findIndex].props.name;
          }
        } else {
          const findIndex = this.dataFindIndex(
            this.outputConditionsItems.datas,
            'display_id',
            input.name
          );
          if (findIndex !== -1) {
            this.outputConditionsItems.datas[findIndex].props.value = input.value;
          }
          conditionItem = this.createSearchConditionList(input, this.csvPayload.conditions);
        }
      }
    }

    if (input.name !== 'plan_actual') {
      const findIndex = this.dataFindIndex(this.csvPayload.conditions, 'id', conditionItem.id);
      if (findIndex === -1) {
        this.csvPayload.conditions.push(conditionItem);
      } else {
        this.csvPayload.conditions[findIndex] = { ...conditionItem };
        if (!this.isSearchValue(conditionItem, input.range !== 'to' ? 0 : 1)) {
          this.csvPayload.conditions.splice(findIndex);
        }
      }
    }
  }

  private dataFindItem(findData: any, findDataString: string, findString: string) {
    const findItem = findData.find((item: any) => {
      if (item[findDataString] === findString) {
        return item;
      }
    });
    return findItem;
  }

  private dataFindIndex(findData: any, findDataString: string, findString: string) {
    const findIndex = findData.findIndex((item: any) => {
      if (item[findDataString] === findString) {
        return item;
      }
    });
    return findIndex;
  }

  private isSearchValue(searchVal: { [key: string]: string | string[] }, index: number) {
    if (searchVal.search_value !== undefined) {
      return searchVal.search_value[index].length === 0 ? false : true;
    } else {
      return true;
    }
  }

  /**
   * 出力条件作成処理
   * @param {object} input - 入力値
   * @param {array} searchConditions - 現状の検索条件
   * @returns {araay} 加工された検索条件
   */
  public createSearchConditionList(
    input: { [k: string]: string },
    searchConditions: Array<{ [key: string]: string | string[] }>
  ) {
    const condition: { [key: string]: any } = {};
    const type = input.type;

    switch (type) {
      case 'datetime': {
        condition['id'] = input.name;
        const range = input.range;
        const currentData = searchConditions.find(v => v.id === input.name);
        if (range && currentData === undefined) {
          if (range === 'from') {
            condition['search_value'] = [this.dataExport.dateToDbDatetime(input.value), null];
          } else if (range === 'to') {
            condition['search_value'] = [null, this.dataExport.dateToDbDatetimeEnd(input.value)];
          }
        } else {
          if (currentData !== undefined) {
            condition['search_value'] = currentData.search_value;
          }
          // const index = range === 'from' ? 0 : 1;
          if (range === 'from') {
            condition['search_value'][0] = this.dataExport.dateToDbDatetime(input.value);
          } else {
            condition['search_value'][1] = this.dataExport.dateToDbDatetimeEnd(input.value);
          }
        }
        break;
      }
      case 'number': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value, input.value];
        break;
      }
      case 'dslookup': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        break;
      }
      case 'status': {
        condition['id'] = input.name;
        condition['search_value'] = typeof input.value === 'object' ? input.value : [input.value];
        break;
      }
      case 'text': {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        condition['exact_match'] = false;
        break;
      }
      case 'select': {
        if (input.name === 'status') {
          condition['id'] = input.name;
          condition['search_value'] = input.value;
        } else {
          condition['id'] = input.name;
          condition['search_value'] = [input.value];
        }
        break;
      }
      default: {
        condition['id'] = input.name;
        condition['search_value'] = [input.value];
        break;
      }
    }
    return condition;
  }

  /**
   * 出力条件のクリアボタン押下処理
   */
  private clearButton() {

    // 出力条件クリアを実行
    this.clearOutputData();
  }

  /**
   * 出力条件クリア
   */
  private clearOutputData() {
    // refを使用しformをリセット
    const form: any = this.$refs.form;
    form.reset();
    // CSV出力内容の初期化
    for(const index in this.outputConditionsItems.datas) {
      switch(this.outputConditionsItems.datas[index].component) {
        case 'MasterSelectSetControl': {
          this.outputConditionsItems.datas[index].props.outPutData[0].value = '';
          break;
        }
        case 'DatePickerRangeArea': {
          this.outputConditionsItems.datas[index].props.valueFrom = '';
          this.outputConditionsItems.datas[index].props.valueTo = '';
          break;
        }
      }
    }

    this.$set(
      this.dataReportOutputSellingSelectPlanAndActualDatas.datas[0].props,
      'value',
      '予定'
    );
    // 出力条件のクリア
    this.csvPayload.conditions = [];
  }

}
